import cepServer from "../../services/server";

const searchCep = (cep, testMode) => {
  return new Promise(async (resolve, reject) => {
    try {
      const server = cepServer(testMode);

      await server
        .get(`/v1/cep/${cep}`)
        .then((response) => {
          const { data } = response;
          const { data: _value } = data;

          resolve({
            cep: _value.cep.replace(/\D/g, "") || "",
            endereco: _value.logradouro || "",
            bairro: _value.bairro || "",
            cidade: _value.nomeMunicipio || "",
            estado: _value.uf || "",
          });
        })
        .catch((error) => {
          const { data: _response } = error.response;
          reject(_response);
        });
    } catch (e) {
      console.log("[e]", e);
      reject(e);
    }
  });
};

export default searchCep;
